import SessionStorage from '../../../../../../../../utils/SessionStorage';
import { AcquisitionFlow, callDataExposureApi } from '../../../../../../../../utils/acquisition-utils';
import { usePqDataManager } from '../../../../../../providers/PqDataManagerProvider';
import axios from 'axios';
import { IOfferModuleCF } from '../../../../../../../../types/shared/OfferModule';

export default function useGetDynamicContent() {
    const {
        pqMappingContent: { partnerId, programCode },
    } = usePqDataManager();

    // TODO: Replace when utility for handling this exists
    const getDynamicContent = async (selectedProgramCode?: string, selectedPartnerId?: string) => {
        const params = new URLSearchParams();
        const currentUrlParams = new URLSearchParams(window.location.search);
        const partnerIdParam = currentUrlParams.get('C1BPartnerID');
        params.set('programCode', selectedProgramCode ?? programCode as string);

        if (selectedPartnerId) {
            params.set('partnerId', selectedPartnerId);
        } else if (partnerId) {
            params.set('partnerId', partnerId);
        } else if (partnerIdParam) {
            params.set('partnerId', partnerIdParam);
        }

        await axios.get(`/services/appoffermodule?${params}`)
            .then(response => response.data as IOfferModuleCF)
            .then(data => {
                if (data) {
                    SessionStorage.setObject('offerContent', data);
                } else {
                    SessionStorage.setObject('offerContent', '{}');
                }
            })
            .then(async () => await callDataExposureApi(AcquisitionFlow.PQ))
            .catch(console.error);

        // returned from legacy
        return 'done';
    };
    return {
        getDynamicContent,
    };
}
